import { inject } from "@angular/core";
import { SignalSubscriptionImpl } from "../data-subscription";
import { CabinetTableView } from "../../../models/types/cabinet.types";
import { BudgetStoreService } from "../../../services/store/budget/budget.store.service";
import { BudgetView } from "../../../models/view/budget/budget.view";

export type TableSource = CabinetTableView;

/**
 * NOTE (#3945): `source` returns `[]` (never `null`) so it never dereferences a null
 * budgetViews() signal. That collapses the `null` initial sentinel the base class uses
 * for `isLoading` (`isLoading = data() === null`), so this table's `isLoading` is always
 * `false` — it intentionally opts out of that contract. No consumer reads it today; if a
 * budget-table spinner is ever needed, drive it from a dedicated flag / store state rather
 * than the null sentinel.
 */
export class BudgetTableSubscription extends SignalSubscriptionImpl<BudgetView[]> {
  protected budgetStoreService: BudgetStoreService = inject(BudgetStoreService);

  get source() {
    // budgetViews() is null initially and on clear (logout/reset); copy before sorting so
    // we don't mutate the stored array. Nullish names: bare a.name?.localeCompare returns
    // undefined (-> 0, so those rows keep insertion order) and localeCompare(null) compares
    // against the literal "null".
    return [...(this.budgetStoreService.budget.budgetViews() ?? [])].sort((a, b) =>
      (a.name ?? "").localeCompare(b.name ?? ""),
    );
  }
}
